import memoizeOne from 'memoize-one';

import {
  DataCenterLegacyStatus,
  Region,
  TechnicalProviderLegacyStatus,
} from 'interfaces/generated.types';

export interface IDatacenterValues {
  id: string;
  name: string;
  region: Region | string;
  bidUrl: string;
  maxQps: string;
  altId?: number;
  journey: string;
  status?: DataCenterLegacyStatus;
  technicalProviderName: string;
  technicalProviderId: string;
}

export const Regions = [
  {
    value: Region.Eu,
    label: 'Europe',
  },
  {
    value: Region.UsEast,
    label: 'US East',
  },
];

export const dataCenterStatusValues = [
  {
    value: DataCenterLegacyStatus.Draft,
    label: 'Draft',
    isDisabled: (value: DataCenterLegacyStatus) =>
      [DataCenterLegacyStatus.Active, DataCenterLegacyStatus.Inactive].includes(value),
  },
  {
    value: DataCenterLegacyStatus.Active,
    label: 'Active',
    isDisabled: (value: DataCenterLegacyStatus) =>
      [DataCenterLegacyStatus.Draft].includes(value),
  },
  {
    value: DataCenterLegacyStatus.Inactive,
    label: 'Inactive',
    isDisabled: (value: DataCenterLegacyStatus) =>
      [DataCenterLegacyStatus.Draft].includes(value),
  },
];

export const getDatacenterStatusData = memoizeOne(
  (
    values: IDatacenterValues,
    technicalProviderStatus: TechnicalProviderLegacyStatus
  ) => [
    {
      status: DataCenterLegacyStatus.Draft,
      required: [
        ...(!values.name ? ["Complete 'Name'"] : []),
        ...(!values.technicalProviderName
          ? ['Complete Parent Programmatic Connector']
          : []),
      ],
    },
    {
      status:
        values.status === DataCenterLegacyStatus.Inactive
          ? DataCenterLegacyStatus.Inactive
          : DataCenterLegacyStatus.Active,
      required: [
        ...(!values.name ? ['Waiting for Name'] : []),
        ...(technicalProviderStatus !== TechnicalProviderLegacyStatus.Active
          ? ['Waiting for Parent Programmatic Connector to be in ACTIVE state']
          : []),
        ...(!values.bidUrl ? ['Waiting for Bid URL'] : []),
      ],
    },
  ]
);

export const datacenterDetailsFields = ['name', 'region', 'bidUrl', 'maxQps'];
